import { useState } from "react";
import { api, fmtDate, formatApiErrorDetail } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Printer } from "lucide-react";
import { toast } from "sonner";

const esc = (s) => String(s ?? "").replace(/[&<>"]/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]));

function labelHtml(d, w) {
  const row = (k, v) => `<tr><td>${k}</td><td>: <b>${esc(v)}</b></td></tr>`;
  return `<html><head><title>Label ${esc(d.kode_produksi)}</title><style>
    @page { size: ${w}mm auto; margin: 2mm; } body { font-family: Arial, sans-serif; margin: 0; width: ${w - 4}mm; color: #000; }
    h1 { font-size: ${w > 60 ? 15 : 12}px; text-align: center; margin: 0 0 3px; border-bottom: 1px solid #000; padding-bottom: 3px; }
    table { font-size: ${w > 60 ? 12 : 10}px; width: 100%; border-collapse: collapse; } td { padding: 1px 0; vertical-align: top; } td:first-child { width: 34%; }
    .qr { text-align: center; margin-top: 4px; } .qr img { width: ${w > 60 ? 34 : 26}mm; }
    .st { text-align: center; font-weight: bold; border: 1.5px solid #000; margin-top: 3px; padding: 2px; font-size: ${w > 60 ? 13 : 11}px; }
  </style></head><body><h1>${esc(d.company)}</h1><table>
    ${row("Tanggal", fmtDate(d.tanggal))}${row("Merek", d.merek)}${row("Jumlah", d.jumlah)}${row("Kode Produksi", d.kode_produksi)}${row("Petugas", d.petugas)}
  </table><div class="st">${esc(d.status)}</div><div class="qr"><img src="${d.qr}" /></div>
  <script>window.onload=()=>{window.print();setTimeout(()=>window.close(),500)}</script></body></html>`;
}

export function ProductLabel({ pb }) {
  const [size, setSize] = useState("58");
  const [busy, setBusy] = useState(false);

  async function print() {
    const win = window.open("", "_blank", "width=420,height=600");
    if (!win) { toast.error("Pop-up diblokir browser. Izinkan pop-up untuk mencetak."); return; }
    setBusy(true);
    try {
      const { data } = await api.get(`/production-batches/${pb.id}/label`);
      win.document.write(labelHtml(data, Number(size)));
      win.document.close();
    } catch (e) { win.close(); toast.error(formatApiErrorDetail(e.response?.data?.detail)); }
    finally { setBusy(false); }
  }

  return (
    <Card className="p-4 space-y-3" data-testid="product-label-card">
      <h4 className="font-heading font-bold text-sm">Cetak Label Stiker Produk Jadi</h4>
      <p className="text-xs text-muted-foreground">Isi label: Tanggal, Merek, Jumlah, Kode Produksi ({pb.tracking_no}), Petugas, Status SELESAI PRODUKSI. Pilih printer thermal Bluetooth yang sudah terpasang di dialog cetak.</p>
      <div className="flex flex-wrap gap-3 items-center">
        <Select value={size} onValueChange={setSize}>
          <SelectTrigger className="w-36" data-testid="plabel-size"><SelectValue /></SelectTrigger>
          <SelectContent><SelectItem value="58">58 mm</SelectItem><SelectItem value="80">80 mm</SelectItem></SelectContent>
        </Select>
        <Button data-testid="plabel-print" disabled={busy} onClick={print}><Printer className="w-4 h-4 mr-1" /> Cetak Label</Button>
      </div>
    </Card>
  );
}
